<template>
  <GlobalWindow
    custom-class="delivery-window"
    :title="title"
    :visible.sync="visible"
    :confirm-working="loading || isWorking"
    @confirm="confirm"
  >
    <el-form :model="form" ref="form" :rules="rules">
      <el-form-item label="交付文件" prop="deliveryFileKey" required>
        <el-upload
          drag
          multiple
          v-loading="loading"
          element-loading-text="上传中"
          accept=".zip"
          :data="{ id: form.id }"
          action="/api/upload/attach"
          :show-file-list="false"
          :on-success="handleUploadSuccess"
          :on-error="handleUploadError"
          :before-upload="handleBeforeUpload"
        >
          <template v-if="form.deliveryFileKey == null || form.deliveryFileKey === ''">
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
          </template>
          <div class="preview" v-else>
            <img src="../../assets/images/zip.svg">
            <p>{{originalFilename}}</p>
          </div>
          <div class="el-upload__tip" slot="tip">只能上传zip文件，且不超过50M</div>
        </el-upload>
      </el-form-item>
    </el-form>
  </GlobalWindow>
</template>

<script>
import BaseOpera from '@/components/base/BaseOpera'
import GlobalWindow from '@/components/common/GlobalWindow'
import { delivery } from '@/api/customer/projectList'
export default {
  name: 'OperaDeliveryFileWindow',
  extends: BaseOpera,
  components: { GlobalWindow },
  data () {
    return {
      originalFilename: '',
      loading: false,
      isWorking: false,
      form: {
        projectId: null,
        deliveryFileKey: null
      },
      rules: {
        deliveryFileKey: [
          { required: true, message: '请上传交付文件' }
        ]
      }
    }
  },
  methods: {
    open (title, row) {
      this.form.projectId = row.id
      this.form.deliveryFileKey = null
      this.originalFilename = ''
      this.title = title
      this.visible = true
      this.loading = false
    },
    // 上传前验证
    handleBeforeUpload (file) {
      // const size = file.size / 1024 / 1024
      // if (size > 5) {
      //   this.$tip.warning('文件大小不能超过' + 50 + 'M')
      //   return false
      // }
      this.loading = true
      return true
    },
    // 上传成功
    handleUploadSuccess (response) {
      if (!response.success) {
        this.$tip.apiFailed(response)
        this.loading = false
        return
      }
      this.form.deliveryFileKey = response.data.fileKey
      this.originalFilename = response.data.originalFilename
      this.loading = false
      this.$refs.form.clearValidate('deliveryFileKey')
    },
    // 上传失败
    handleUploadError () {
      this.loading = false
    },
    // 确定
    confirm () {
      this.$refs.form.validate(pass => {
        if (!pass) {
          return
        }
        if (this.isWorking) {
          return
        }
        this.isWorking = true
        delivery(this.form)
          .then(() => {
            this.$emit('success')
            this.visible = false
          })
          .catch(e => {
            this.$tip.apiFailed(e)
          })
          .finally(() => {
            this.isWorking = false
          })
      })
    }
  }
}
</script>

<style lang="scss">
.delivery-window {
  .el-upload, .el-upload-dragger {
    width: 100%;
  }
  .preview {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    p {
      margin-bottom: 0;
    }
  }
}
</style>
